import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TakeawayServices } from '../../../services';

/**
 * Generated class for the TpvTicketSelectedPersonsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-select-selected-persons',
  templateUrl: 'takeaway-order-select-selected-persons.html',
})
export class TakeawayOrderSelectSelectedPersonsPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices) {
  }

  ionViewDidLoad() {

  }

  updatePersons() {
    this.takeawayServices.tableUpdatePersons(this.takeawayServices.keyboard_screen);
    this.takeawayServices.keyboard_screen = '';
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-select/takeaway-order-select-selected/takeaway-order-select-selected-persons/takeaway-order-select-selected-persons.ts